import {
    faMugSaucer,
    faCalendarCheck,
    faWallet,
    faBagShopping,
    faBurgerGlass,
    faMegaphone,
} from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { UserActionsMenuItemConfig } from "./TopBarNewButtonMenu"

export type TopBarNewMenuItemId =
    | "resource-booking"
    | "meeting-service"
    | "take-away"
    | "make-purchase"
    | "refill-wallet"
    | "push-message"

type BaseItemConfig = Readonly<Omit<UserActionsMenuItemConfig, "onClick">>

const TOP_BAR_NEW_MENU_BASE_ITEMS: Record<TopBarNewMenuItemId, BaseItemConfig> = {
    "resource-booking": {
        icon: faCalendarCheck,
        color: "purple",
        title: (
            <LocalizedStrict id="top-bar-new-menu-resource-booking-title">
                <>Resource booking</>
            </LocalizedStrict>
        ),
        description: (
            <LocalizedStrict id="top-bar-new-menu-resource-booking-description">
                <>Book rooms and other resources</>
            </LocalizedStrict>
        ),
    },
    "meeting-service": {
        icon: faMugSaucer,
        color: "teal",
        title: (
            <LocalizedStrict id="top-bar-new-menu-meeting-service-title">
                <>Meeting service</>
            </LocalizedStrict>
        ),
        description: (
            <LocalizedStrict id="top-bar-new-menu-meeting-service-description">
                <>Order meeting service</>
            </LocalizedStrict>
        ),
    },
    "take-away": {
        icon: faBurgerGlass,
        color: "amber",
        title: (
            <LocalizedStrict id="top-bar-new-menu-take-away-title">
                <>Takeaway</>
            </LocalizedStrict>
        ),
        description: (
            <LocalizedStrict id="top-bar-new-menu-take-away-description">
                <>Purchase takeaway and other goods</>
            </LocalizedStrict>
        ),
    },
    "make-purchase": {
        icon: faBagShopping,
        color: "green",
        title: (
            <LocalizedStrict id="top-bar-new-menu-make-purchase-title">
                <>Make a purchase</>
            </LocalizedStrict>
        ),
        description: (
            <LocalizedStrict id="top-bar-new-menu-make-purchase-description">
                <>Order lunch at the canteen</>
            </LocalizedStrict>
        ),
    },
    "refill-wallet": {
        icon: faWallet,
        color: "slate",

        title: (
            <LocalizedStrict id="top-bar-new-menu-refill-wallet-title">
                <>Refill wallet</>
            </LocalizedStrict>
        ),
        description: (
            <LocalizedStrict id="top-bar-new-menu-refill-wallet-description">
                <>Top up money at your digital wallet</>
            </LocalizedStrict>
        ),
    },
    "push-message": {
        icon: faMegaphone,
        color: "pink",
        title: (
            <LocalizedStrict id="top-bar-new-menu-push-message-title">
                <>Push message</>
            </LocalizedStrict>
        ),
        description: (
            <LocalizedStrict id="top-bar-new-menu-push-message-description">
                <>Send messages to your customers</>
            </LocalizedStrict>
        ),
    },
}

export function createTopBarNewMenuItem(id: TopBarNewMenuItemId, onClick: () => void): UserActionsMenuItemConfig {
    const base = TOP_BAR_NEW_MENU_BASE_ITEMS[id]

    return {
        ...base,
        onClick,
    }
}
